<template>
  <div>
    <v-layout v-if="loading" justify-center column fill-height style="min-height: 300px">
      <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="45"
          width="3"
        ></v-progress-circular>
      </div>
    </v-layout>
    <template v-else>
      <v-container>
        <v-layout>
          <v-flex>
            <h1>{{ $t('beacon_message') }}</h1>
          </v-flex>
        </v-layout>

        <v-layout v-if="intents.length > 1">
          <v-flex xs12 sm6 class="form-control">
            <input
              v-model.lazy="search"
              type="text"
              class="form-control"
              :placeholder="$t('search_beacon_message')"
              style="margin-bottom: 10px"
            />
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn outline color="primary" @click="expandAll">
              <i class="fas fa-expand-arrows-alt mr-1"></i>
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn outline color="primary" @click="collapseAll">
              <i class="fas fa-compress mr-1"></i>
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <div>
          <div style="margin-bottom: 10px">
            <a v-if="!isShow" href="javascript:void(0);" @click="addCommentToInbox">
              <div class="add-conversation text-xs-center">
                <i class="fa fa-plus middle"></i>
                {{ $t('add_beacon_message') }}
              </div>
            </a>

            <div v-else class="intent-item z-border-red" style="padding: 10px 15px 0px">
              <manage-intent
                v-model="intent"
                :is-comment-to-inbox="false"
                :is-beacon="true"
                :hide-choice="true"
                :excluded-intent-name="excludedIntentName"
                @close="onClose"
                @saveIntent="onSaveIntent"
              ></manage-intent>
            </div>
          </div>

          <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
            <v-pagination
              v-model="pageNumber"
              :total-visible="15"
              :length="pageCount"
            ></v-pagination>
          </div>

          <intent-item
            v-for="(item, index) in paginateIntent"
            :key="'intent_' + item.id + '_' + index"
            v-model="paginateIntent[index]"
            :is-livechat="true"
            :filter-intents="paginateIntent"
            :is-comment-to-inbox="false"
            :excluded-intent-name="excludedIntentName"
            :is-beacon="true"
            :hide-choice="true"
            @onDelete="handleDeleteIntent(index)"
            @onCopyIntent="copyIntent"
            @onUpdate="onUpdateIntent"
          ></intent-item>

          <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
            <v-pagination
              v-model="pageNumber"
              :total-visible="15"
              :length="pageCount"
            ></v-pagination>
          </div>
        </div>
      </v-container>

      <div class="mt-5 mb-5"></div>
    </template>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import TransferIntent from '@/components/view/intent/TransferIntent'
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import manageIntent from '@/components/view/intent/intent-manage'
import intentItem from '@/components/view/intent/intent-item'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'
import bbqApi from '@/api/bbq'

export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    ModalDialog,
    ModalHelp,
    TransferIntent
  },
  data() {
    return {
      loading: false,
      isShow: false,
      showModal: false,
      pageNumber: 1,
      showsize: 20,

      intent: {
        campaign_name: '',
        q_type: 'text',
        a_type: 'json',
        q_val: 'exacts(beacon_enter)',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        status: true
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_comment_to_inbox: undefined,
      max_intent: 300
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    paginateIntent() {
      const vm = this
      let result = null
      if (vm.filterIntents.length >= vm.showsize) {
        const start = (vm.pageNumber - 1) * vm.showsize
        const end = vm.pageNumber * vm.showsize
        result = vm.filterIntents.slice(start, end)
        return result
      } else {
        result = vm.filterIntents
      }

      return result
    },
    showPagination() {
      if (this.filterIntents.length >= this.showsize) {
        return true
      }
      return false
    },
    pageCount: function () {
      let l = this.filterIntents.length
      let s = this.showsize
      return Math.ceil(l / s)
    },
    filterIntents: function () {
      const vm = this
      if (!vm.intents) return []
      let intents = vm.intents
      if (this.filterContext) {
        intents = intents.filter((el) => {
          return el.context_in == this.filterContext
        })
      }

      intents.sort(function (a, b) {
        const nameA = a.campaign_name.toUpperCase() // ignore upper and lowercase
        const nameB = b.campaign_name.toUpperCase() // ignore upper and lowercase
        if (a.campaign_name[0] == '{' && a.campaign_name[a.campaign_name.length - 1] == '}') {
          return 1
        }
        if (b.campaign_name[0] == '{' && b.campaign_name[b.campaign_name.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      let filteredIntent = intents.filter((intent) => {
        const isFound =
          ((intent.campaign_name &&
            intent.campaign_name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.q_val && intent.q_val.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_in &&
              intent.context_in.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_out &&
              intent.context_out.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.a_val && intent.a_val.toLowerCase().includes(vm.search.toLowerCase()))) &&
          !['comment', 'facebooklive'].includes(intent.context_in)
        return isFound
      })

      filteredIntent = filteredIntent.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      )

      // filteredIntent = filteredIntent.sort((x, y) =>
      //   x.status === y.status ? 0 : x.status ? -1 : 1
      // )
      return filteredIntent
    },
    excludedIntentName: function () {
      let result = []
      const vm = this
      if (vm.allIntents) {
        result = vm.allIntents.map(function (intent, index) {
          return intent.campaign_name
        })
      }
      return result.join(',')
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter((el) => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.campaign_name
        )
      })
      return intentwithoutwelcome.length
    },
    isBeaconPage() {
      return this.selectedBot.unlock_beacon
    }
  },
  mounted: function () {
    const vm = this
    vm.loading = true
    const packageConfig = vm.getPackageConfig()
    vm.max_intent = packageConfig.reply_comment

    vm.getWelcomeMessage(function () {
      vm.getIntent()
    })

    if (
      vm.selectedBot.theme == 'ecommercebasic' ||
      vm.$store.state.shoptheme.includes(vm.selectedBot.theme)
    ) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')

    if (vm.isBeaconPage) {
      vm.handleInitialBeacon()
    }
    vm.loading = false
  },
  methods: {
    beforeEnter: function (el) {
      el.style.opacity = 0
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    async onSaveIntent(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        vm.intents.push(payload)
        vm.intent = {
          ...vm.intentBeaconTemplate()
        }
        vm.lastedIntentName = payload.campaign_name
        await vm.getIntent()
        vm.$store.commit('CLEAR_LOADING')
        vm.$swal.fire({
          title:
            vm.$t('conversation') +
            ' "' +
            payload.campaign_name.replace(/\<|\>/g, '') +
            '" ' +
            vm.$t('added'),
          type: 'success',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    copyIntent: function (payload) {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= this.max_intent &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then((result) => {
          result.isShow = true
          this.intents.push(result)
          // this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              result.campaign_name.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function (payload) {
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      this.isShow = false
    },
    async getIntent() {
      const vm = this
      try {
        vm.loading = true
        const response = await beaconApi.getIntentBeacon({
          config: { pageid: vm.selectedBot.pageid }
        })
        vm.loading = false
        handleResponse(response)

        if (response && response.data && response.data.success) {
          let intents = response.data.result.map(function (val) {
            let intent = { ...val }
            intent.isShow = false
            intent.ableToDelete = true
            return intent
          })
          vm.allIntents = intents
          vm.intents = intents

          let default_comment_to_inbox = intents.find((el) => {
            return el.campaign_name == '{default_comment_to_inbox}'
          })

          if (default_comment_to_inbox) {
            default_comment_to_inbox.ableToDelete = false
            vm.default_comment_to_inbox = default_comment_to_inbox
          } else {
            vm.default_comment_to_inbox = {
              ...vm.intentBeaconTemplate(),
              ableToDelete: false,
              isShow: false
            }

            vm.default_comment_to_inbox.campaign_name = '{default_comment_to_inbox}'
          }
        }
      } catch (error) {
        vm.loading = false
        handleApiError(error)
      }
    },
    async handleDeleteIntent(index) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.paginateIntent[index].campaign_name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          const id = vm.paginateIntent[index].id

          vm.$store.dispatch('loading')
          const response = await vm.deleteIntentBeacon(id)
          vm.$store.commit('CLEAR_LOADING')

          if (response && response.status === 200) {
            vm.getIntent()
          }
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async deleteIntentBeacon(id) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await beaconApi.deleteIntentBeacon({
          pageId: vm.selectedBot.pageid,
          id: id
        })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    addCommentToInbox() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= this.max_intent &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.welcome_message.type = response.data.type
          vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function (index, val) {
              vm.welcome_message.generics[index] = val
            })
          }

          if (
            response.data.message_quickreplies &&
            response.data.message_quickreplies !== '' &&
            response.data.message_quickreplies != null
          ) {
            vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
          } else {
            vm.welcome_message.quick_reply = []
          }
        }
        callback()
      })
    },
    expandAll: function () {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', true)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', true)
    },
    collapseAll: function () {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', false)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', false)
    },
    onUpdateIntent: function (payload) {
      var vm = this
      $.each(vm.intents, function (index, intent) {
        if (intent.id == payload.id) {
          vm.intents[index] = payload
          return false
        }
      })
    },
    async getBeaconsList() {
      const vm = this
      try {
        vm.loading = true
        const response = await beaconApi.getBeaconsList({
          pageId: vm.selectedBot.pageid,
          config: { limit: 1000, offset: 0 }
        })
        vm.loading = false
        handleResponse(response)
        if (response && response.status === 200 && response.data && response.data.success) {
          const tempResult = response.data.result || []
          vm.$store.state.beaconMasterData.beaconBranch = tempResult
        }
      } catch (error) {
        vm.loading = false
        handleApiError(error)
      }
    },
    async getAudienceList() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: 100,
          offset: 0
        }
        vm.loading = true
        const response = await bbqApi.getAudienceList({
          config: data
        })
        vm.loading = false
        handleResponse(response)
        if (response && response.status === 200) {
          const tempData = response.data.data || []
          vm.$store.state.beaconMasterData.groupAudience = tempData
        }
      } catch (error) {
        vm.loading = false
        handleApiError(error)
      }
    },
    async handleInitialBeacon() {
      try {
        await this.getBeaconsList()
        await this.getAudienceList()
      } catch (error) {
        console.error(error)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/Messages.vue